import LoadableCrudResources from './loadable_crud_resources'
import ReactComponent from 'lib/modulor/react_component'

ReactComponent.register(LoadableCrudResources, 'Modulor.CrudResources')
